import classNames from 'classnames';

const rootCss = {
  position: 'relative',
  width: '100%',
  '&:after': {
    content: '""',
    display: 'block',
    paddingBottom: '56.25%',
  },

  '.ARW-wrapper': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
};

export default function AspectRatioWrapper(props) {
  const { children, className, wrapperClassName, ...rest } = props;
  return (
    <div className={className} css={rootCss}>
      <div className={classNames(wrapperClassName, 'ARW-wrapper')} {...rest}>
        {children}
      </div>
    </div>
  );
}
